import './administrator-view.component.ajscss';

import { UserTrackingFunction } from '@tracking/models/tracking-function';
import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './administrator-view.component.ajs.html';

const MODULE_NAME = 'contactAdministratorView';

class AdministratorViewControler implements IComponentController {
  public name = MODULE_NAME;
  public UserTrackingFunction = UserTrackingFunction;
  $onInit() {}
}

export class AdministratorView implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {};
  controller = [AdministratorViewControler];
}

export default MODULE_NAME;
